import { HttpClient, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ILoginDto } from './models/login-dto';
import { SERVICES_API } from '@pro-connect/shared';

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  constructor(
    @Inject(SERVICES_API)
    private readonly _servicesApi: string,
    private readonly _httpClient: HttpClient,
  ) {}

  /**
   * Login customer by username and password. Returns token.
   * @param loginDto
   * @param recaptchaKey
   */
  public login(loginDto: ILoginDto, recaptchaKey: string): Observable<HttpResponse<Object>> {
    return this._httpClient.post(`${this._servicesApi}/pro/login/check-user`, loginDto, {
      params: {
        recaptchaKey,
      },
      observe: 'response',
      withCredentials: true,
    });
  }
}
